var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"site-logo",attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("@/assets/img/pilihlaptop-logo-min.png"),"alt":"PilihLaptop.com","title":"PilihLaptop.com","loading":"lazy"}})])}
var staticRenderFns = []

export { render, staticRenderFns }